class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  async open(triggeredBy) {
  const regionId = document.querySelector('#cart-icon-bubble');
  const regionIdValue = regionId.getAttribute('region-id');
  if (regionIdValue === 'United Kingdom' || regionIdValue === 'Estonia') {
    let countryCode = document.querySelector(`#FooterCountry-country-results li a[id="${regionIdValue}"]`).dataset.value;
    let cart = await fetch('/cart.js').then(r => r.json());
    let conCode = null;
    if(cart.item_count>0){
      for(let item of cart.items){
        conCode = item.properties['_region'];
        if(conCode !== regionIdValue){
          const buttons = document.querySelector('.header__icon--cart');
          showRegionPopup(buttons);
          return;
        }
      }
    }
  }

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
     //  this.initTosValidation(); 
    });
  }
  
//  initTosValidation() {
//   const tosCheckbox = this.querySelector('#cart-tos-checkbox');
//   const errorMsg    = this.querySelector('#cart-tos-error');
//   const checkoutBtn = this.querySelector('#CartDrawer-Checkout');

//   if (!tosCheckbox || !checkoutBtn) return;

//   //checkoutBtn.disabled = !tosCheckbox.checked;
  
//   tosCheckbox.addEventListener('change', () => {

//     const value = tosCheckbox.checked ? "Yes" : "No";

//     fetch('/cart/update.js', {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         attributes: { "Terms And Conditions": value }
//       })
//     });

//     if (tosCheckbox.checked) {
//       checkoutBtn.disabled = false;
//     } else {
//        e.target.form.submit();
//     }
//   });

//   checkoutBtn.addEventListener('click', (e) => {
//     if (!tosCheckbox.checked) {
//       e.preventDefault();
//      alert("You must agree with the terms and conditions of sales to check out.");
//       return false;
//     }
//   });
// }



  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

async function checkCartitem(){
  const regionId = document.querySelector('#product_region_id');
  const regionIdValue = regionId.getAttribute('region-id');
  if (regionIdValue === 'United Kingdom' || regionIdValue === 'Estonia') {
    let countryCode = document.querySelector(`#FooterCountry-country-results li a[id="${regionIdValue}"]`).dataset.value;
    let cart = await fetch('/cart.js').then(r => r.json());
    let conCode = null;
    if(cart.item_count>0){
      for(item of cart.items){
        conCode = item.properties['_region'];
        if(conCode !== regionIdValue){
          const buttons = document.querySelector('.header__icon--cart');
          showRegionPopup(buttons);
          return;
        }
      }
    }
  }
}

function showRegionPopup(targetBtn) {
  const tooltip = document.getElementById("region-tooltipcart");
  tooltip.style.display = "block";
  const rect = targetBtn.getBoundingClientRect();
}

function hideRegionTooltip() {
  document.getElementById("region-tooltipcart").style.display = "none";
}

document.getElementById("tooltip-cancel").addEventListener("click", hideRegionTooltip);

document.getElementById("tooltip-clear-cart").addEventListener("click", () => {
  const regionId = document.querySelector('#cart-icon-bubble');
    if (regionId) {
      const regionIdValue = regionId.getAttribute('region-id');
      fetch('/cart/clear.js').then(r => r.json()).then(()=>{
            document.querySelector(`#FooterCountry-country-results li a[id="${regionIdValue}"]`).click();
      });
    }
});